import styles from "./toasNotification.module.css";

const ToastNotification = ({ message, useInfoIcon }: { message: string; useInfoIcon?: boolean }) => (
  <>
    <div
      className={styles.crossImage}
      style={{
        width: "50px",
        backgroundImage: useInfoIcon
          ? "url(/assets/images/notification-icon-info.png)"
          : "url(/assets/images/notification-icon-error.png)",
      }}
    />
    <p className={styles.message} dangerouslySetInnerHTML={{ __html: message }}></p>
  </>
);

export default ToastNotification;
